// extracted by mini-css-extract-plugin
module.exports = {"errorBlock":"FormErrorMessage_errorBlock__1W_Ql","hasError":"FormErrorMessage_hasError__3oKyX","errorMessage":"FormErrorMessage_errorMessage__3SOR4"};